export const FILE_PREFIX = 'CRM_CPR_';
export const EXPORT_LOG_TYPE = 'log';

export const DEFAULT_TOKEN_TYPE = 'Bearer';
